import React from "react";
import { MultiSelect } from "primereact/multiselect";
import { Button, DatePicker, Uploader } from "rsuite";
import { FaCaretDown } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";

function AddStaffBasic({ formik, isEditMode }) {

  const fileList =
    typeof formik.values.ProfilePicture === "string"
      ? [
          {
            name: formik.values.ProfilePicture,
            fileKey: 1,
            url: formik.values.ProfilePicture,
            status: "finished",
          },
        ]
      : formik.values.ProfilePicture instanceof File
      ? [
          {
            name: formik.values.ProfilePicture.name,
            fileKey: 2,
            file: formik.values.ProfilePicture,
            blobFile: formik.values.ProfilePicture,
            status: "finished",
          },
        ]
      : [];

  return (
    <>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Basic Information
            </h5>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Full Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Full Name"
              value={formik.values.fullname}
              name="fullname"
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
                formik.setFieldValue("fullname", value);
              }}
              disabled={isEditMode}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Gender<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="Gender"
                name="gender"
                value={formik.values.gender}
                onChange={(e) => formik.setFieldValue("gender", e.target.value)}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="others">Others</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Date of Birth<span className="text-danger">*</span>
            </label>
            <DatePicker
              name="dateofbirth"
              value={formik.values.dateofbirth ? new Date(formik.values.dateofbirth) : null}
              onChange={(value) => formik.setFieldValue("dateofbirth", value)}
              format="dd-MMM-yyyy"
              placeholder="dd-mmm-yyyy"
              oneTap
              style={{ width: "100%", height: "33px", borderRadius: "4px" }}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Phone Number<span className="text-danger">*</span>
            </label>
            <PhoneInput
              country="in"
              onlyCountries={["in"]}
              disableDropdown={true}
              countryCodeEditable={false}
              value={formik.values.phonenumber}
              onChange={(value, country) => {
                formik.setFieldValue("phonenumber", value);
                formik.setFieldValue("countryCode", `+${country.dialCode}`);
              }}
              inputClass="form-control"
              specialLabel=""
              inputProps={{
                name: "phonenumber",
              }}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              E-mail Address<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter E-mail Address"
              value={formik.values.email}
              name="email"
              onChange={(e) => formik.setFieldValue("email", e.target.value)}
              disabled={isEditMode}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Profile Picture<span className="text-danger">*</span>
            </label>

            <Uploader
              accept=".jpeg,.jpg,.png"
              multiple={false}
              fileListVisible={true} 
              fileList={fileList} 
              onChange={(fileList) => {
                const file = fileList?.[0]?.blobFile || null;
                formik.setFieldValue("ProfilePicture", file);
              }}
              onRemove={() => formik.setFieldValue("ProfilePicture", null)}
              action=""
              autoUpload={false}
            >
              <Button
                className="form-control"
                style={{
                  width: "100%",
                  height: "2.5rem",
                  fontSize: "0.875rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                  color: "#6c757dca",
                }}
              >
                Select to select file
              </Button>
            </Uploader>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">Emergency Contact Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Emergency Name"
              value={formik.values.emergencyname}
              name="refferedby"
              onChange={(e) => formik.setFieldValue("refferedby", e.target.value)}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">Emergency Contact Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Emergency Phone"
              value={formik.values.emergencynumber}
              name="refferedby"
              onChange={(e) => formik.setFieldValue("refferedby", e.target.value)}
            />
          </div>
        </div>

        <div className="col-12 col-md-12">
          <div className="mb-3">
            <div className="d-flex align-items-center w-50 gap-2 div-kasxoakxm">
              <label className="col-form-label abt-pr">
               Address<span className="text-danger">*</span>
              </label>
            </div>
            <textarea
              className="form-control"
              placeholder="Enter Address"
              style={{
                color: "rgb(66, 66, 66)",
                height: "110px",
                letterSpacing: "0.5px",
                fontSize: "0.9rem",
                padding: "0.8rem",
                lineHeight: "1.7",
              }}
              name="address"
              value={formik.values.address}
              onChange={(e) => formik.setFieldValue("address", e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddStaffBasic;
